import { DataTypeForm, validateTaxId, Labels } from "../../../../../features/data-types"
import { Data, FieldType, FormField, option } from "../../../../../features/ui"
import { useActions } from "./actions"
import { Supplier } from "../../../state/types"
import { useEffect, useState } from "react"
import { useGenerateNextValue } from "../../../../../tables/hooks"
import { TableName } from "../../../../../tables"
import { TaxCategory } from "../../../../operations"

type Props = {
    productSupplier?: boolean
    onSubmit: (supplier: Supplier) => void
    onCancel?: () => void
}

export const SupplierQuickForm = (props: Props) => {
    const { productSupplier = true, onSubmit, onCancel } = props

    const [code, setCode] = useState(1)

    const generateNextValue = useGenerateNextValue()

    const { submitSupplier } = useActions()

    const init = async () => {
        setCode(await generateNextValue(TableName.SUPPLIERS, 'code'))
    }
    
    useEffect(() => {
        init()
    }, [])

    const fields: FormField[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        },
        {
            name: 'taxId',
            type: FieldType.NUMBER,
            label: 'CUIT / CUIL',
            validate: validateTaxId
        },
        {
            name: 'taxCategory',
            type: FieldType.SELECT,
            label: 'Cateogría Fiscal',
            options: Object.values(TaxCategory).map(taxCategory => option(taxCategory, Labels.taxCategoryLabel(taxCategory)))
        }
    ]

    const handleSubmit = async (supplierData: Data) => {
        const savedSupplier = await submitSupplier(supplierData, code, productSupplier)
        onSubmit(savedSupplier)
    }

    const handleCancel = () => onCancel?.()

    return (
        <DataTypeForm
            formId="supplier-quick-form"
            fields={fields}
            createMode={true}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
